import script from "./SchemaWeights.vue?vue&type=script&setup=true&lang=js"
export * from "./SchemaWeights.vue?vue&type=script&setup=true&lang=js"

import "./SchemaWeights.vue?vue&type=style&index=0&id=11710deb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11710deb"]])

export default __exports__